const background = {
    methods: {
        setBg(bg) {
            return {
                backgroundImage: `url(${bg})`
            }
        }
    }
};
export default background;